import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Stack, Typography, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Images } from "../../../assets/common";

export default function ProfileStats({ userData, isOwnerId, onTipClick }) {
  const { t } = useTranslation("common");
  const history = useHistory();
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-evenly"
      spacing={1}
      sx={{
        border: "0.5px solid #3E3E3E",
        borderRadius: "8px",
        marginTop: "20px",
        padding: "10px 34px",
        [theme.breakpoints.down("sm")]: {
          padding: "20px 10px",
        },
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        sx={{
          cursor: "pointer",
          paddingRight: "34px",
          [theme.breakpoints.down("sm")]: {
            paddingRight: "20px",
          },
        }}
        onClick={() =>
          history.push(`/app/Follow/${userData["_id"]}`, { userData })
        }
      >
        <Typography className="fs-20 fw-b _cp">
          {userData["followerCount"]}
        </Typography>
        <Stack direction="row" alignItems="center">
          <Typography className="fs-14 light-text _cp">
            {t("artistProfile.followers")}
          </Typography>
          <ArrowForwardIosIcon
            sx={{ fontSize: "14px" }}
            color="default"
          />
        </Stack>
      </Stack>

      <Divider
        sx={{ color: "#3E3E3E", height: "40px" }}
        orientation="vertical"
      />
      
      <Stack
        direction="column"
        alignItems="center"
        sx={{
          cursor: "pointer",
          padding: isOwnerId ? "0 0 0 34px" : "0 34px",
          [theme.breakpoints.down("sm")]: {
            padding: isOwnerId ? "0 0 0 20px" : "0 20px",
          },
        }}
        onClick={() =>
          history.push(`/app/Following/${userData["_id"]}`, { userData })
        }
      >
        <Typography className="fs-20 fw-b _cp">
          {userData["followingCount"]}
        </Typography>
        <Stack direction="row" alignItems="center">
          <Typography className="fs-14 light-text _cp">
            {t("artistProfile.following")}
          </Typography>
          <ArrowForwardIosIcon
            sx={{ fontSize: "14px" }}
            color="default"
          />
        </Stack>
      </Stack>
      
      {!isOwnerId && (
        <>
          <Divider
            sx={{ color: "#3E3E3E", height: "40px" }}
            orientation="vertical"
          />
          <Stack
            direction="column"
            alignItems="center"
            sx={{
              paddingLeft: "34px",
              [theme.breakpoints.down("sm")]: {
                paddingLeft: "20px",
              },
            }}
          >
            <Typography className="fs-14 text-left">
              {t("tipContainer.subHeader")}
            </Typography>
            <Stack
              className="_cp"
              direction="row"
              alignItems="center"
              gap="5px"
              padding="8px"
              onClick={onTipClick}
            >
              <img src={Images.tip_player} alt="tip_player" />
              <Typography color="primary" className="fs-14 nowrap _cp">
                {t("tipBox.button")}
              </Typography>
            </Stack>
          </Stack>
        </>
      )}
    </Stack>
  );
}